import { render, staticRenderFns } from "./workLoad.vue?vue&type=template&id=154d0fca"
import script from "./workLoad.vue?vue&type=script&lang=js"
export * from "./workLoad.vue?vue&type=script&lang=js"
import style0 from "./workLoad.vue?vue&type=style&index=0&id=154d0fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports